module.exports = __webpack_public_path__ + "img/logo-bootstrap-materialdesign.40b6facf.png";